import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ContentsSection } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox, Popup } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { InputItemBox } from "component/basic/formItems";
import { getDateGap, setDateTime } from "js/function";
import { DateSelectPopup } from "pages/popup/Popup";
import { FixedPage, FixedSection } from "component/basic";
import { CarDetailControllBasicText, CarDetailControllBox, CarDetailSection, CarDetailTextArea, CarDetailTextBox, CarSetInfoItem, CarSetInfoSection, FixedContents, PopupBottomCaption, PopupNameTextComBox } from "component/product/page";

const ReservationEditDate = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const id = param.id;

    const location = useLocation();
    const locationData = location?.state ? location?.state : null;
    const paymentData = locationData?.paymentData;
    const pageData = locationData?.pageData;
    const memberCode = locationData?.memberCode;

    const rentDay = pageData ? getDateGap(pageData?.start_date,pageData?.end_date,"time",null) : 0;

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(false);

    const [submitChk,setSubmitChk] =  useState(true);

    const [dateSelectPopupData,setDateSelectPopupData] =  useState(null);
    
    const [paymentDataDate,setPaymentDataDate] = useState(paymentData);

    const [startDate,setStartDate] = useState(null);
    const [endDate,setEndDate] = useState(null);
    
    const [popupData,setPopupData] =  useState(null);
    const [popupFailedData,setPopupFailedData] =  useState(null);

    function dateSelectPopupOpen(){
		setDateSelectPopupData({
			addClass:null,
			title:"대여/반납 일시 선택",
			closeType:true,
			closeFunc:(e) => {setDateSelectPopupData(null)}
		});
  	}

    function dateFunc(start,end){
        if(submitChk){
            setSubmitChk(false);
            setLoadingBoxOpen(true);

            let formData = new FormData();

            formData.append("start_date", start);
            formData.append("end_date", end);
            formData.append("company_mapped_code", paymentData?.cCode ? paymentData?.cCode : pageData?.company_mapped_code ? pageData?.company_mapped_code : "");
            formData.append("model_mapped_code", paymentData?.mCode ? paymentData?.mCode : pageData?.model_mapped_code ? pageData?.model_mapped_code : "");

            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/reservation/modify/check`,
                success: (apiData) => {
                    setSubmitChk(true);
                    setLoadingBoxOpen(false);

                    setPopupData({
                        addClass:null,
                        title:"일정 변경 가능",
                        text:"선택하신 일시로 예약 변경이 가능합니다.<br/>일정 변경을 진행할까요?",
                        closeType:true,
                        closeFunc:(e) => {setPopupData(null);setDateSelectPopupData(null)},
                        btnFunc0:(e)=>{setPopupData(null);setDateSelectPopupData(null)},
                        btn0:"취소",
                        btn0Type:"subColor",
                        btn1:"변경하기",
                        btn1Type:"",
                        btnFunc1:()=>{
                            setPopupData(null);
                            let oldData = {...paymentDataDate};
                            oldData.start_date = start;
                            oldData.end_date = end;
                            setPaymentDataDate(oldData);
                    
                            setDateSelectPopupData(null);
                        }
                    });
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        setPopupFailedData({
                            addClass:null,
                            title:"일정 변경 불가",
                            text:"선택하신 일시로 예약 변경이 불가합니다.<br/>다른 일정으로 변경하시거나 해당 예약을 취소 후,<br/>새롭게 예약을 진행해주세요.",
                            closeType:true,
                            closeFunc:(e) => {setPopupFailedData(null);setDateSelectPopupData(null)},
                            btnFunc0:(e)=>{setPopupFailedData(null);setDateSelectPopupData(null)},
                            btn0:"취소",
                            btn0Type:"subColor",
                            btn1:"다시 선택하기",
                            btn1Type:"",
                            btnFunc1:()=>{setPopupFailedData(null)}
                        });
                    }
                    setLoadingBoxOpen(false);
                }
            })
        }
    }

    return (
        <>
            <ContentsSection
                header={true}
                footer={false}
                pcFooter={true}
                addClass={"gBg mBtnPoint"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"일정 변경"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={1}
                    closeFunc={()=>{}}
                />

                <FixedPage addClass="detailFixedPage">
                    <FixedContents addClass="">
                        <CarDetailSection title="기존 일정 정보">
                            <CarDetailTextArea title={null} addClass="">
                                <CarDetailTextBox
                                    addClass=""
                                    name={`대여일시`}
                                    text={pageData?.start_date ? setDateTime(pageData?.start_date,"dayyyMinmmddhh",null) : "-"}
                                />
                                <CarDetailTextBox
                                    addClass=""
                                    name={`반납일시`}
                                    text={pageData?.end_date ? setDateTime(pageData?.end_date,"dayyyMinmmddhh",null) : "-"}
                                />
                            </CarDetailTextArea>
                        </CarDetailSection>
                        <CarDetailSection title="변경할 일정 정보">
                            <CarDetailTextArea title={null} addClass="">
                                <InputItemBox
                                    inputType={null}
                                    boxAddClass=""
                                    inputName="지역"
                                    placeholder="위치 선택"
                                    value={"제주국제공항"}
                                    max={null}
                                    regexp={null}
                                    errMsg={null}
                                    readOnly={true}
                                    func={(value)=>{}}
                                />
                                <InputItemBox
                                    inputType={null}
                                    boxAddClass=""
                                    inputName="대여/반납 일시"
                                    placeholder="대여/반납 일시 선택"
                                    value={paymentDataDate?.start_date && paymentDataDate?.end_date ? `${setDateTime(paymentDataDate?.start_date,"daymmddhh",null)} ~ ${setDateTime(paymentDataDate?.end_date,"daymmddhh",null)}` : null}
                                    inputSubName={paymentDataDate?.start_date && paymentDataDate?.end_date ? `${getDateGap(paymentDataDate?.start_date,paymentDataDate?.end_date,"time",null)} 시간` : null}
                                    max={null}
                                    regexp={null}
                                    errMsg={null}
                                    readOnly={true}
                                    func={(value)=>{}}
                                    clickInput={()=>{dateSelectPopupOpen()}}
                                />
                            </CarDetailTextArea>
                        </CarDetailSection>
                    </FixedContents>
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass=""
                        addClass="nonFixed mNonMb"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <CarDetailControllBox
                            addClass={"nonFixed"}
                            title={"변경할 일정을 선택해주세요."}
                            subTitle={null}
                        >
                            <CarDetailControllBasicText
                                addClass="subText"
                                text={"대여 차량 기준 예약 가능한 일정에 한하여 일정을 변경할 수 있으며 대여시간이 변경될 경우 추가 요금이 발생합니다."}
                            />
                            <CarSetInfoSection>
                                <CarSetInfoItem
                                    addClass=""
                                    name="기존 대여시간"
                                    text={`${rentDay} 시간`}
                                />
                                <CarSetInfoItem
                                    addClass=""
                                    name="변경 대여시간"
                                    text={`${paymentDataDate?.start_date && paymentDataDate?.end_date ? getDateGap(paymentDataDate?.start_date,paymentDataDate?.end_date,"time",null) : "0"} 시간`}
                                />
                            </CarSetInfoSection>
                            <BtnBox
                                boxType=""
                                addClass={"mFixed col2"}
                            >
                                <BtnItem
                                    addClass="dbColor"
                                    contents="뒤로"
                                    func={() => {
                                        navigate(-1)
                                    }}
                                />
                                <BtnItem
                                    addClass=""
                                    contents={`선택 완료`}
                                    func={() => {
                                        navigate(`/reservation/edit/${id}`,{state:{paymentData:paymentDataDate,pageData:pageData,memberCode:memberCode}})
                                    }}
                                />
                            </BtnBox>
                        </CarDetailControllBox>
                    </FixedSection>
                </FixedPage>
            </ContentsSection>
            <Footer pcOnly={true}/>
            <DateSelectPopup
                popupData={dateSelectPopupData}
                btnType={true}
                subBtnText={"취소"}
                subBtnFunc={()=>{
                    setDateSelectPopupData(null);
                }}
                btnText={"선택 완료"}
                btnFunc={(start,end)=>{
                    dateFunc(start,end);
                    setStartDate(start);
                    setEndDate(end);
                }}
            />
            <Popup
                data={popupData}
            >
                <PopupNameTextComBox
                    name="변경 대여일시"
                    text={startDate ? setDateTime(startDate,"dayyyMinmmddhh",null) : "-"}
                />
                <PopupNameTextComBox
                    name="변경 반납일시"
                    text={endDate ? setDateTime(endDate,"dayyyMinmmddhh",null) : "-"}
                />
                <PopupBottomCaption
                    text={"대여 차량 기준 예약 가능한 일정에 한하여 일정을 변경할 수 있으며 대여시간이 변경될 경우 추가 요금이 발생합니다."}
                />
            </Popup>
            <Popup
                data={popupFailedData}
            /> 
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default ReservationEditDate;